import { pick } from 'lodash';
export const pickCalendarProps = (props) => {
    return pick(props, 'isCalendarFixedHeight', 'monthsToDisplay', 'isDateUnavailable', 'defaultFocusedDate', 'showOutsideDays', 'showTodayButton', 'shouldSetDateOnTodayButtonClick');
};
